const REVIEW_ACTION =
  {
    APPROVE: 'APPROVE',
    DECLINE: 'DECLINE',
    RETURN_APPLICATION: 'RETURN_APPLICATION',
    AMEND: 'AMEND',
    AMEND_WITH_WORKFLOW: 'AMEND_WITH_WORKFLOW'
  };

module.exports = REVIEW_ACTION;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/server/shared/constants/review-action.constant.js
// module id = BsKx
// module chunks = 1